import { IconSvg } from 'Components/shared/Icon/index.generated';
import * as React from 'react';
import { SidebarMenuItem } from '~/lib/ui/sidebar';
import { Switch } from '~/lib/ui/switch';

interface EntityProfileActionProps {
  icon: keyof typeof IconSvg;
  label: string;
  onClick: () => void;
  switchProps?: {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
  };
  disabled?: boolean;
  loading?: boolean;
}

export const EntityProfileAction: React.FC<EntityProfileActionProps> = ({
  icon,
  label,
  onClick,
  switchProps,
  disabled = false,
}) => {
  const isDisabled = disabled || switchProps?.disabled;

  const iconNode = IconSvg[icon];

  return (
    <SidebarMenuItem className="px-0">
      <div
        className={`p-1.5 flex items-center justify-between rounded-lg ${
          isDisabled
            ? 'cursor-default opacity-50'
            : 'cursor-pointer hover:bg-accent'
        }`}
        onClick={isDisabled ? undefined : onClick}
      >
        <div className="flex items-center gap-1.5">
          {iconNode && (
            <span className="size-6 flex items-center justify-center">
              {IconSvg[icon]}
            </span>
          )}
          {label && <span>{label}</span>}
        </div>
        {switchProps && (
          <Switch
            checked={switchProps.checked}
            onCheckedChange={
              isDisabled ? undefined : switchProps.onCheckedChange
            }
            onClick={(e) => e.stopPropagation()}
            disabled={switchProps.disabled}
            className={isDisabled ? 'cursor-none' : 'cursor-pointer'}
          />
        )}
      </div>
    </SidebarMenuItem>
  );
};
